<template>
  <div id="header">
    <div class="container">
      <div class="logo">
        <router-link :to="{ path: '/' }">
          <img :src="`/static/images/logos/trm-${$root.marathon.id}.png`" alt="TRM Logo" />
        </router-link>
      </div>
      <div class="hamburger-menu" @click="toggleHamburger">
        <span class="fa fa-bars"></span>
      </div>
      <div class="navigation-area" :class="{ hamburgerOpen: hamburgerOpen }">
        <div class="social-media">
          <ul class="social-channels">
            <li
              v-for="(social, index) in $root.social"
              :class="social.platform.toLowerCase()"
              :key="`social.item.${index}`"
            >
              <a :href="social.link" target="_blank" :title="social.platform">
                <span :class="`fa fa-${social.platform.toLowerCase()}`"></span>
              </a>
            </li>
          </ul>
        </div>
        <ul class="nav">
          <li
            v-for="(item, index) in navItems"
            class="trm-nav-item"
            :class="item.title.toLowerCase().replace(/ /g, ``)"
            :key="`nav.item.${index}`"
          >
            <router-link v-if="item.isExternal !== true" :to="{ path: item.link }">{{ item.title }}</router-link>
            <a v-else :href="item.link" target="_blank">{{ item.title }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "navbar",
  data() {
    return {
      hamburgerOpen: false
    };
  },

  mounted() {
    document.addEventListener("click", e => {
      if (
        e.target.className.indexOf("hamburger") > -1 ||
        e.target.className.indexOf("fa-bars") > -1
      ) {
        return;
      }

      this.hamburgerOpen = false;
    });
  },

  computed: {
    navItems() {
      let items = [];
      items.push(
        { link: "/", title: "Tomb Raider Marathon" },
        // {
        //   link: "https://horaro.org/trm/seven",
        //   title: "Schedule",
        //   isExternal: true
        // },
        { link: "/history", title: "History" }
      );

      if (
        this.$root.marathon.mode == `marathon` ||
        this.$root.marathon.mode == `donate`
      )
        items.push({
          link: "//donate.tombraidermarathon.com",
          title: "Donate",
          isExternal: true
        });

      return items;
    }
  },

  methods: {
    toggleHamburger() {
      this.hamburgerOpen = !this.hamburgerOpen;
    }
  }
};
</script>

<style scoped lang="scss">
#header {
  background: $navbar-bg-col;
  border-bottom: 1px solid $navbar-border-col;
  color: $default-fg-col;
  height: $navbar-height;
  padding: 0 15px;
  width: 100%;

  @media screen and (max-width: $phone-size) {
    position: fixed;
    top: 0;
    z-index: 300;
  }

  .container {
    align-items: center;
    display: flex;
    height: 100%;
  }

  .logo {
    height: 100%;
    margin-right: 30px;
    padding: 5px 0;
    width: auto;

    img {
      height: 100%;
    }

    @media screen and (max-width: $phone-size) {
      img {
        height: 20px;
      }
    }
  }

  .hamburger-menu {
    display: none;

    .fa:before {
      font-size: 1.5rem;
    }

    @media screen and (max-width: $phone-size) {
      display: inline-block;
      margin-left: auto;
    }
  }

  .navigation-area {
    align-items: center;
    display: flex;
    height: 100%;
    width: 100%;

    @media screen and (max-width: $phone-size) {
      background: $navbar-bg-col;
      box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
      display: none;
      height: auto;
      left: 0;
      position: fixed;
      right: 0;
      top: $navbar-height;
      z-index: 300;

      &.hamburgerOpen {
        display: inline-block;
      }

      .social-channels {
        clear: both;
        display: flex;
        float: left;
        justify-content: center;
        padding: 10px 0;
        width: 100%;
      }

      .nav {
        width: 100%;
      }

      .trm-nav-item {
        clear: both;
        display: inline-block;
        text-align: center;
        width: 100%;
      }
    }
  }

  .social-channels {
    .fa:before {
      color: $default-fg-col;
      font-size: 1.25rem;
    }

    li {
      align-items: center;
      clear: none;
      display: flex;
      float: left;
      text-align: center;

      &:not(:first-child) {
        margin-left: 20px;
      }

      .fa {
        &:before {
          font-size: 1rem;
          line-height: 20px;
        }

        border-radius: 50%;
        height: 30px;
        padding: 5px;
        width: 30px;
      }

      &.twitch {
        .fa {
          &:before {
            color: $twitch-fg-col;
          }

          background: $twitch-bg-col;
        }
      }

      &.twitter {
        .fa {
          &:before {
            color: $twitter-fg-col;
          }

          background: $twitter-bg-col;
        }
      }

      &.facebook {
        .fa {
          &:before {
            color: $facebook-fg-col;
          }

          background: $twitter-bg-col;
        }
      }

      &.discord {
        .fa {
          &:before {
            color: $discord-fg-col;
          }

          background: $discord-bg-col;
        }
      }
    }
  }

  .nav {
    clear: both;
    display: inline-block;
    height: 100%;
    line-height: $navbar-height;
    margin-left: auto;
    width: auto;

    li {
      clear: none;
      color: #ddd;
      float: left;
      font-size: 1rem;
      height: 100%;
      padding: 0 10px;
      width: auto;

      &.donate {
        background: $marathon-col;

        a {
          &,
          &:link,
          &:visited {
            color: $alt-fg-col;
            border-radius: 10px;
            font-weight: bold;
            padding: 0 5px;
          }
        }

        &:hover {
          background: lighten($marathon-col, 5%);
        }
      }

      &:hover {
        background: rgba(darken($navbar-bg-col, 10%), 0.7);
      }

      a {
        &,
        &:link,
        &:visited {
          color: $default-fg-col;
          display: inline-block;
          height: 100%;
          text-decoration: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Navbar.vue?2eac16c1